<template>
  <b-modal
    title="Novo importador"
    id="new_importer"
    size="xl"
    hide-footer
    @show="resetForm()"
    @shown="$refs.autofocus.focus()"
  >
    <b-overlay :show="loading">
      <b-row>
        <b-col>
          <warning-required-fields />
        </b-col>
      </b-row>
      <errors-messages :errors="errors" />
      <b-row>
        <b-col>
          <label-required-field label="Tabela alvo" />
          <b-select v-model="new_importer_table" @change="onTableChange()">
            <b-select-option value>ESCOLHA</b-select-option>
            <b-select-option
              v-for="table in tables"
              :key="table"
              :value="table"
            >
              {{ table }}
            </b-select-option>
          </b-select>
        </b-col>
        <b-col>
          <label-required-field label="Categoria" />
          <b-input ref="autofocus" v-model="new_importer_name"> </b-input>
        </b-col>
      </b-row>
      <hr />
      <label-required-field label="Colunas associativas" />
      <b-row>
        <b-col>
          <label-required-field label="Coluna da tabela" />
          <b-select v-model="add_associative_table_column">
            <b-select-option value>ESCOLHA</b-select-option>
            <b-select-option
              v-for="column in add_available_table_columns"
              :key="column"
              :value="column"
            >
              {{ column }}
            </b-select-option>
          </b-select>
        </b-col>
        <b-col>
          <label-required-field label="Coluna no arquivo" />
          <b-input v-model="add_associative_file_column"></b-input>
        </b-col>
        <b-col cols="auto">
          <label>Restrição</label>
          <b-checkbox v-model="add_associative_allow_null">
            Permitir NULL
          </b-checkbox>
          <small class="text-muted">
            Importar itens com valor NULL neste campo
          </small>
        </b-col>
        <b-col cols="auto">
          <v-btn
            class="v-primary"
            style="margin-top: 36px"
            @click="addAssociativeColumn()"
          >
            <span class="fa fa-plus" /> ADICIONAR
          </v-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-data-table
            dense
            :headers="associativeHeaders"
            :items="associativeItems"
            @click:row="removeAssociativeColumn"
          >
            <template v-slot:[`item.allow_null`]="{ item }">
              {{ item.allow_null ? "PERMITIR" : "NÃO PERMITIR" }}
            </template>
          </v-data-table>
        </b-col>
      </b-row>
      <hr />
      <label-required-field label="Colunas relacionais" />
      <b-row>
        <b-col>
          <label-required-field label="Coluna da tabela" />
          <b-select v-model="add_relational_table_column">
            <b-select-option value>ESCOLHA</b-select-option>
            <b-select-option
              v-for="column in add_available_table_columns"
              :key="column"
              :value="column"
            >
              {{ column }}
            </b-select-option>
          </b-select>
        </b-col>
        <b-col>
          <label-required-field label="Coluna no arquivo" />
          <b-input v-model="add_relational_file_column" />
        </b-col>
        <b-col cols="auto">
          <label>Restrição</label>
          <b-checkbox v-model="add_relational_allow_null"
            >Permitir NULL</b-checkbox
          >
          <small class="text-muted">
            Importar itens com valor NULL neste campo
          </small>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label-required-field label="Tabela relacionada" />
          <b-select
            v-model="add_relational_related_table"
            @change="onRelatedTableChange"
          >
            <b-select-option value>ESCOLHA</b-select-option>
            <b-select-option
              v-for="column in new_importer_related_tables"
              :key="column"
              :value="column"
            >
              {{ column }}
            </b-select-option>
          </b-select>
        </b-col>
        <b-col>
          <label-required-field label="Coluna da tabela relacionada" />
          <b-select v-model="add_relational_related_table_column">
            <b-select-option value>ESCOLHA</b-select-option>
            <b-select-option
              v-for="column in new_importer_related_table_columns"
              :key="column"
              :value="column"
            >
              {{ column }}
            </b-select-option>
          </b-select>
        </b-col>
        <b-col>
          <label-required-field label="Coluna-valor da tabela relacionada" />
          <b-select v-model="add_relational_related_table_column_value">
            <b-select-option value>ESCOLHA</b-select-option>
            <b-select-option
              v-for="column in new_importer_related_table_columns"
              :key="column"
              :value="column"
            >
              {{ column }}
            </b-select-option>
          </b-select>
        </b-col>
        <b-col cols="auto">
          <v-btn
            class="v-primary"
            style="margin-top: 36px"
            @click="addRelationalColumn()"
          >
            <span class="fa fa-plus" /> ADICIONAR
          </v-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-data-table
            dense
            :headers="relationalHeaders"
            :items="relationalItems"
            @click:row="removeRelationalColumn"
          >
            <template v-slot:[`item.allow_null`]="{ item }">
              {{ item.allow_null ? "PERMITIR" : "NÃO PERMITIR" }}
            </template>
          </v-data-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-right">
          <v-btn class="v-success" @click="create">
            <span class="fa fa-check" /> SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import toast from "../../components/ToastNotification";
import { dialogConfirm } from "../../lib/functions";
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import LabelRequiredField from "../components/LabelRequiredField.vue";
import WarningRequiredFields from "../components/WarningRequiredFields.vue";
export default {
  name: "NewImporter",
  components: {
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
  },
  data() {
    return {
      errors: [],
      loading: false,

      tables: [],

      new_importer_name: "",
      new_importer_table: "",
      new_importer_table_columns: [],
      new_importer_related_tables: [],
      new_importer_related_table_columns: [],

      add_available_table_columns: [],

      add_associative_table_column: "",
      add_associative_file_column: "",
      add_associative_allow_null: false,
      associativeHeaders: [
        { text: "Coluna da Tabela", value: "table_column" },
        { text: "Coluna do arquivo", value: "file_column" },
        { text: "NULL", value: "allow_null" },
      ],
      associativeItems: [],

      add_relational_table_column: "",
      add_relational_file_column: "",
      add_relational_related_table: "",
      add_relational_related_table_column: "",
      add_relational_related_table_column_value: "",
      add_relational_allow_null: false,
      relationalHeaders: [
        { text: "Coluna da Tabela", value: "table_column" },
        { text: "Coluna do CSV", value: "file_column" },
        { text: "Tabela Relacionada", value: "related_table" },
        { text: "Coluna da Tabela Relacionada", value: "related_table_column" },
        {
          text: "Coluna-valor da Tabela Relacionada",
          value: "related_table_column_value",
        },
        { text: "NULL", value: "allow_null" },
      ],
      relationalItems: [],
    };
  },
  created() {
    this.getTables();
  },
  methods: {
    dialogConfirm,
    async resetForm() {
      this.errors = [];
      this.loading = false;
      this.new_importer_name = "";
      this.new_importer_table = "";
      this.new_importer_table_columns = [];
      this.new_importer_related_tables = [];
      this.new_importer_related_table_columns = [];
      this.add_available_table_columns = [];
      this.add_associative_table_column = "";
      this.add_associative_file_column = "";
      this.add_associative_allow_null = false;
      this.associativeItems = [];
      this.add_relational_table_column = "";
      this.add_relational_file_column = "";
      this.add_relational_related_table = "";
      this.add_relational_related_table_column = "";
      this.add_relational_related_table_column_value = "";
      this.add_relational_allow_null = false;
      this.relationalItems = [];
    },
    /**events */
    async onTableChange() {
      await this.getTableColumns();
      this.associativeItems = [];
      this.relationalItems = [];
      this.new_importer_related_tables = this.tables.filter(
        (element) => element != this.new_importer_table
      );
    },
    async onRelatedTableChange() {
      await this.getRelationedTableColumns();
    },
    async removeAssociativeColumn(item) {
      let self = this;
      this.dialogConfirm("Deseja remover esta coluna?", () => {
        self.associativeItems = self.associativeItems.filter(
          (element) => element != item
        );
        self.add_available_table_columns.push(item.table_column);
        self.add_available_table_columns.sort();
      });
    },
    async removeRelationalColumn(item) {
      let self = this;
      this.dialogConfirm("Deseja remover esta coluna?", () => {
        self.relationalItems = self.relationalItems.filter(
          (element) => element != item
        );
        self.add_available_table_columns.push(item.table_column);
        self.add_available_table_columns.sort();
      });
    },
    async create() {
      try {
        this.loading = true;

        let data = {
          table: this.new_importer_table,
          name: this.new_importer_name,
          associative: this.associativeItems,
          relational: this.relationalItems,
        };
        let response = await api.post("/importer", data);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("created");
          this.$bvModal.hide("new_importer");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    /**retrievers */
    async getTables() {
      try {
        this.loading = true;

        let response = await api.get("/importer/tables");
        let { error, errors, tables } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.tables = tables;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getTableColumns() {
      let columns = await this.getColumns(this.new_importer_table);
      this.new_importer_table_columns = columns;
      this.add_available_table_columns = columns;
    },
    async getRelationedTableColumns() {
      let columns = await this.getColumns(this.add_relational_related_table);
      this.new_importer_related_table_columns = columns;
    },
    async getColumns(table) {
      try {
        if (!table) {
          return [];
        }
        this.loading = true;

        let params = { table };
        let response = await api.get("/importer/columns", { params });
        let { error, errors, columns } = response.data;

        if (error) {
          this.errors = errors;
          this.loading = false;
          return [];
        } else {
          this.loading = false;
          return columns;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**associative columns */
    async addAssociativeColumn() {
      if (
        !this.add_associative_table_column ||
        !this.add_associative_file_column
      ) {
        return;
      }
      this.associativeItems.push({
        table_column: this.add_associative_table_column,
        file_column: this.add_associative_file_column,
        allow_null: this.add_associative_allow_null,
      });

      this.add_available_table_columns = this.add_available_table_columns.filter(
        (column) => column != this.add_associative_table_column
      );

      this.add_associative_table_column = "";
      this.add_associative_file_column = "";
      this.add_associative_allow_null = false;
    },
    /**relational columns */
    async addRelationalColumn() {
      if (
        !this.add_relational_table_column ||
        !this.add_relational_file_column ||
        !this.add_relational_related_table ||
        !this.add_relational_related_table_column ||
        !this.add_relational_related_table_column_value
      ) {
        return;
      }
      this.relationalItems.push({
        table_column: this.add_relational_table_column,
        file_column: this.add_relational_file_column,
        related_table: this.add_relational_related_table,
        related_table_column: this.add_relational_related_table_column,
        related_table_column_value: this
          .add_relational_related_table_column_value,
        allow_null: this.add_relational_allow_null,
      });

      this.add_available_table_columns = this.add_available_table_columns.filter(
        (column) => column != this.add_relational_table_column
      );

      this.add_relational_table_column = "";
      this.add_relational_file_column = "";
      this.add_relational_related_table = "";
      this.add_relational_related_table_column = "";
      this.add_relational_related_table_column_value = "";
      this.add_relational_allow_null = false;
      this.new_importer_related_table_columns = [];
    },
  },
};
</script>

<style>
</style>